export default __webpack_public_path__ + "static/media/Departments_w.d789beac.svg";